import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourerEducations`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerEducations/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerEducations/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add (labourerEducation) {
    const payload = jsona.serialize({
        stuff: labourerEducation,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourerEducations`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (labourerEducation) {
    const payload = jsona.serialize({
        stuff: labourerEducation,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/labourerEducations/${labourerEducation.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/labourerEducations/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

